"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const postFeedback_1 = __importDefault(require("./postFeedback"));
const postSendOrderByEmail_1 = __importDefault(require("./postSendOrderByEmail"));
const createEmailClient = (axios) => ({
    postFeedback: ({ content }) => postFeedback_1.default({
        axios,
        content
    }),
    postSendOrderByEmail: ({ shipmentId, data }) => (postSendOrderByEmail_1.default({ axios, shipmentId, data }))
});
exports.default = createEmailClient;
